export default __webpack_public_path__ + "static/media/e4f6dd38d10e5b775ee8d14a39fa6a62.d422bd0c.svg";